define('app/models/DashboardCollection',['require','glu/collection','config','glu/$','./Dashboard'],function(require) {
	'use strict';

	var Collection = require('glu/collection'),
		config = require('config'),
		$ = require('glu/$'),
		Dashboard = require('./Dashboard');

	return Collection.extend({
		url: config.apiRoot + 'service/dashboards',
		model: Dashboard,

		getSelectedDashboard: function() {
			var self = this;
			return $.grep(self.models, function(e) {
				return e.get('isSelected');
			})[0];
		}
	});
});

